var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('postulant-english-promotion-component',{attrs:{"postulantCreateUI":_vm.postulant_create_UI,"postulantListRoute":_vm.postulant_list_route}})}
var staticRenderFns = []

export { render, staticRenderFns }